import script from "./MyButtonBase.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyButtonBase.vue?vue&type=script&setup=true&lang=ts"

import "./MyButtonBase.vue?vue&type=style&index=0&id=053fbd72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-053fbd72"]])

export default __exports__